const baseEnv = (baseApi: string, additionalProps) => {
  const isBackApi = Boolean(process.env.BACKEND_VERSION && additionalProps.isProduction)

  return {
    baseApi,
    route: {
      baseRoute: '/spa/',
    },
    api: {
      auth: baseApi,
      profile: baseApi,
      config: baseApi,
      promo: baseApi,
      region: baseApi,
      processing: isBackApi ? process.env.BASE_API_HOST : baseApi,
      aft: isBackApi ? process.env.BASE_API_HOST : baseApi,
      settings: baseApi,
      autoPayments: baseApi,
      cms: baseApi,
      paymentApi: baseApi,
      threeDSApi: baseApi,
      ump: isBackApi ? process.env.API_MTSBANK_MTS_HOST : process.env.NEXT_PUBLIC_UMP_PATH,
    },
    isProduction: typeof additionalProps.isProduction !== 'undefined' ? additionalProps.isProduction : true,
    isDevelopment: typeof additionalProps.isDevelopment !== 'undefined' ? additionalProps.isDevelopment : false,
    isTesting: typeof additionalProps.isTesting !== 'undefined' ? additionalProps.isTesting : false,
  }
}

export type Environment = ReturnType<typeof baseEnv>

export default baseEnv
